import { observer } from 'mobx-react-lite';
import { View, Pressable, Platform } from 'react-native';
import { TestIDs } from 'src/constants/testIDs.constants';
import { useStore } from 'src/contexts/StoreContext';
import { ACTIVE_TOOLS } from 'src/store/page-project/pageProject.constants';
import { brand, text } from 'src/theme/colors';
import { Icon } from '../../../icon/Icon';
import { ICON_NAMES } from '../../../icon/icon.helper';
import TextLato from '../../../text/text-lato/TextLato';
import Modal from '@photosi/rn-components/modals/modal';
import { styleDesktop, styleMobile } from './ModalAdjustCrops.styles';
import { FocusGroups } from '../../../focus-provider/FocusProvider.constants';
import { useEffect, useState } from 'react';
import { ImagesGrid } from './ImagesGrid';
import { TOAST_IDS } from '../../../toast/Toast.constants';
import {
  DYNAMIC_MODAL_ACTIONS,
  DYNAMIC_MODAL_VIEWS,
} from 'src/store/_models/dynamic-modal-layer/dynamicModalLayer.constants';
import { DynamicModalProps } from '../DynamicModal.types';
import { MODAL_CUT_CONFIRMATION_TYPE } from '../modal-cut-confirmation-alert/ModalCutConfirmationAlert.types';
import amplitude from 'src/_shared/amplitude';
import { AnalyticsEvents } from 'src/_shared/analyticsEvents';
import useResponsiveScreen from 'src/hooks/useResponsiveScreen';
import { GRID_DEFAULT_COLUMNS_NUMBER_DESKTOP, GRID_DEFAULT_COLUMNS_NUMBER_MOBILE } from './ModalAdjustCrops.constants';
import Animated, { useAnimatedStyle } from 'react-native-reanimated';
import { modalTestID } from 'src/helpers/testIDs.helper';
import { useAddToCartHandlers } from 'src/hooks/useAddToCartHandlers';
import { SecondaryButton } from 'src/editor-v3/components/buttons/secondary-button/SecondaryButton';
import { BUTTON_SIZES, BUTTON_TYPES } from 'src/editor-v3/components/buttons/button/Button.constants';
import { PrimaryButton } from 'src/editor-v3/components/buttons/primary-button/PrimaryButton';
import { PressableHovered } from 'src/editor-v3/components/pressable-hovered/PressableHovered';

const NUM_COLUMNS_OPTIONS_DESKTOP = [
  // {
  //   numColumns: 0, // SLIDESHOW
  //   icon: ICON_NAMES.GridView3,
  // },
  {
    numColumns: 2,
    icon: ICON_NAMES.GridView2,
  },
  {
    numColumns: 3,
    icon: ICON_NAMES.GridView1,
  },
  {
    numColumns: 5,
    icon: ICON_NAMES.GridView4,
  },
];
const NUM_COLUMNS_OPTIONS_MOBILE = [
  {
    numColumns: 1,
    icon: ICON_NAMES.GridView25,
  },
];
export const ModalAdjustCrops = observer(
  ({ dynamicModalVisible, type, dynamicModalLayer: { id } }: DynamicModalProps) => {
    const {
      i18n,
      project,
      dynamicModal: { closeModal: _closeModal, openModal, closeVisibleModals: _closeVisibleModals },
      toolbarDesktop: { setIsToolbarOpen },
      project: { setActiveTool },
      toastStore: { hideToast },
    } = useStore();
    const { handleClickAddToCart } = useAddToCartHandlers();
    const { isDesktop } = useResponsiveScreen();
    const styles = isDesktop ? styleDesktop : styleMobile;
    const GRID_DEFAULT_COLUMNS_NUMBER = isDesktop
      ? GRID_DEFAULT_COLUMNS_NUMBER_DESKTOP
      : GRID_DEFAULT_COLUMNS_NUMBER_MOBILE;

    const [gridColumns, setGridColumns] = useState<number>(GRID_DEFAULT_COLUMNS_NUMBER);
    const NUM_COLUMNS_OPTIONS = isDesktop ? NUM_COLUMNS_OPTIONS_DESKTOP : NUM_COLUMNS_OPTIONS_MOBILE;
    const currentColumnOption =
      NUM_COLUMNS_OPTIONS.find(o => o.numColumns === gridColumns) ??
      NUM_COLUMNS_OPTIONS.find(o => o.numColumns === GRID_DEFAULT_COLUMNS_NUMBER);
    // const activeUserImage = project.activeUserImageArea?.userImage;
    // const canUndo = !!activeUserImage?.canUndo;
    // const canRedo = !!activeUserImage?.canRedo;

    useEffect(() => {
      amplitude.trackEvent(AnalyticsEvents.personalize.photoFrameView, {
        n_photo: project.activeProject!.userImageAreasWithCropAlert.length,
      });
    }, []);

    const counter = project.activeProject!.userImageAreasWithCropAlert.length;

    const closeModal = () => {
      setActiveTool(ACTIVE_TOOLS.frame);
      setIsToolbarOpen(false);
      _closeModal();
    };

    const closeVisibleModals = () => {
      setActiveTool(ACTIVE_TOOLS.frame);
      setIsToolbarOpen(false);
      _closeVisibleModals();
    };

    // const onPressUndo = async () => {
    //   canUndo && activeUserImage?.undo();
    // };

    // const onPressRedo = async () => {
    //   canRedo && activeUserImage?.redo();
    // };

    const onPressSave = async () => {
      const imagesEdited = project.activeProject!.userImageAreasWithCropAlert?.some(
        item => item?.userImage?.isUserEdited,
      );
      function goToCart() {
        const userImageIds = project.activeProject?.userImageAreasWithCropAlert.map(userImageArea => {
          return userImageArea.userImage!.id;
        });
        project.activeProject?.deactivateCropAlert(userImageIds ?? []);
        closeVisibleModals(); // close CutConfirmationAlert POPUP modal and AdjustCrops FULLSCREEN modal
        handleClickAddToCart();
      }
      if (!imagesEdited) {
        openModal({
          dynamicModalView: DYNAMIC_MODAL_VIEWS.CutConfirmationAlert,
          modalCutType: MODAL_CUT_CONFIRMATION_TYPE.CONFIRM,
          actionCallback: (action: DYNAMIC_MODAL_ACTIONS) => {
            switch (action) {
              case DYNAMIC_MODAL_ACTIONS.CONTINUE:
                hideToast(TOAST_IDS.CutsCheckAlert);
                amplitude.trackEvent(AnalyticsEvents.personalize.photoFrameSaveOptionClick, { option: 'confirm' });
                goToCart();
                break;
              default:
                closeModal(); // close CutConfirmationAlert POPUP modal
                amplitude.trackEvent(AnalyticsEvents.personalize.photoFrameSaveOptionClick, { option: 'close' });
                break;
            }
          },
        });
      } else {
        goToCart();
      }

      amplitude.trackEvent(AnalyticsEvents.personalize.photoFrameSaveClick);
    };
    const onPressReviewLater = async () => {
      function goToCart() {
        const userImageIds = project.activeProject?.userImageAreasWithCropAlert.map(userImageArea => {
          return userImageArea.userImage!.id;
        });
        project.activeProject?.deactivateCropAlert(userImageIds ?? []);
        closeVisibleModals(); // close CutConfirmationAlert POPUP modal and AdjustCrops FULLSCREEN modal
        handleClickAddToCart();
      }
      openModal({
        dynamicModalView: DYNAMIC_MODAL_VIEWS.CutConfirmationAlert,
        modalCutType: MODAL_CUT_CONFIRMATION_TYPE.LATER,
        actionCallback: (action: DYNAMIC_MODAL_ACTIONS) => {
          switch (action) {
            case DYNAMIC_MODAL_ACTIONS.CONTINUE:
              hideToast(TOAST_IDS.CutsCheckAlert);
              amplitude.trackEvent(AnalyticsEvents.personalize.photoFrameSaveOptionClick, { option: 'confirm' });
              goToCart();
              break;
            default:
              closeModal(); // close CutConfirmationAlert POPUP modal
              amplitude.trackEvent(AnalyticsEvents.personalize.photoFrameSaveOptionClick, { option: 'close' });
              break;
          }
        },
      });
      amplitude.trackEvent(AnalyticsEvents.personalize.photoFramePostponeCutReview);
    };
    const gridColumnsHandler = () => {
      const currentIndex = NUM_COLUMNS_OPTIONS.findIndex(o => o.numColumns === gridColumns);
      const nextIndex = (currentIndex + 1) % NUM_COLUMNS_OPTIONS.length;
      const nextColumnOption = NUM_COLUMNS_OPTIONS[nextIndex];
      setGridColumns(nextColumnOption.numColumns);
      amplitude.trackEvent(AnalyticsEvents.personalize.viewLayoutClick, {
        type: nextColumnOption.numColumns,
        context: 'review_cut_view',
      });
    };

    useEffect(() => {
      hideToast(TOAST_IDS.CutsCheckAlert);
      return () => {
        project.activeGroup?.checkToastNotifications();
      };
    }, []);

    const animatedContainerStyle = useAnimatedStyle(() => {
      if (Platform.OS !== 'web') return {};

      return {
        backdropFilter: 'blur(24px)',
        WebkitBackdropFilter: 'blur(24px)',
      };
    }, []);

    return (
      <Modal
        style={styles.modalContainer}
        style_container={styles.modalContent}
        showHeader={false}
        isInstant={true}
        visible={dynamicModalVisible}
        testID={TestIDs.ADJUST_CROPS}
        onClose={() => closeModal()}
        closeOnClickOutside={false}
        type={type}
        id={id}
      >
        <View style={styles.contentWrapper}>
          {/* Header */}
          <View style={styles.header}>
            <View style={[styles.headerElement, styles.headerLeft]}>
              {isDesktop && (
                <SecondaryButton
                  accessible={true}
                  accessibilityLabel={i18n.t('header:save-project')}
                  accessibilityRole="button"
                  focusGroup={FocusGroups.MODAL_HEADER}
                  focusOrder={0}
                  focusId={TestIDs.REVIEW_LATER}
                  testID={modalTestID(TestIDs.ADJUST_CROPS, TestIDs.REVIEW_LATER)}
                  text={i18n.t('modal-adjust-crops:review-later')}
                  onPress={onPressReviewLater}
                  onFocus={e => e.stopPropagation()}
                  iconName={ICON_NAMES.ArrowLeft2}
                  type={BUTTON_TYPES.ICON_LEFT}
                  size={BUTTON_SIZES.REGULAR}
                  layout="hug"
                />
              )}
            </View>
            <View style={[styles.headerElement, styles.headerCenter]}>
              <TextLato style={styles.modalTitle}>{i18n.t('modal-adjust-crops:title')}</TextLato>
            </View>

            <View style={[styles.headerElement, styles.headerRight]}>
              {/* <View style={styles.undoRedoContainer}>
              <Pressable style={styles.iconButtonWrapperUndoRedo} onPress={() => onPressUndo()}>
                <View style={{ width: 14, height: 14 }}>
                  <Icon name={ICON_NAMES.Undo} color={brand.main.water} />
                </View>
              </Pressable>
              <Pressable style={styles.iconButtonWrapperUndoRedo} onPress={() => onPressRedo()}>
                <View style={{ width: 14, height: 14 }}>
                  <Icon name={ICON_NAMES.Redo} color={brand.main.water} />
                </View>
              </Pressable>
            </View> */}
              {isDesktop ? (
                <>
                  <View style={styles.counter}>
                    <TextLato style={styles.counterText}>{i18n.t('zoom-image:photos', { counter })}</TextLato>
                  </View>
                  <View style={styles.divider} />
                  <PressableHovered
                    style={styles.gridButton}
                    onPress={gridColumnsHandler}
                    hint={i18n.t('group-action-bar:grid')}
                    accessibilityLabel={i18n.t('group-action-bar:grid')}
                    accessibilityRole="button"
                    focusGroup={FocusGroups.MODAL_HEADER}
                    focusOrder={1}
                  >
                    <View style={styles.gridIcon}>
                      <Icon name={currentColumnOption?.icon ?? ICON_NAMES.GridView4} color={text.color.interactive} />
                    </View>
                  </PressableHovered>
                  <View>
                    <PrimaryButton
                      accessible={true}
                      accessibilityLabel={i18n.t('modal-adjust-crops:save_and_close')}
                      accessibilityRole="button"
                      focusGroup={FocusGroups.MODAL_HEADER}
                      focusOrder={2}
                      focusId={TestIDs.SAVE_AND_CLOSE}
                      testID={modalTestID(TestIDs.ADJUST_CROPS, TestIDs.SAVE_AND_CLOSE)}
                      text={i18n.t('modal-adjust-crops:save_and_close')}
                      onPress={onPressSave}
                      onFocus={e => e.stopPropagation()}
                      size={BUTTON_SIZES.REGULAR}
                      type={BUTTON_TYPES.DEFAULT}
                      layout="hug"
                    />
                  </View>
                </>
              ) : (
                <View style={styles.counter}>
                  <TextLato style={styles.counterText}>{i18n.t('zoom-image:photos', { counter })}</TextLato>
                </View>
              )}
            </View>
          </View>

          {/* Main Content */}

          <ImagesGrid
            userImageAreas={project.activeProject!.userImageAreasWithCropAlert}
            numColumns={currentColumnOption!.numColumns}
          />
          {!isDesktop && (
            <Animated.View style={[styles.ctaWrapper, animatedContainerStyle]}>
              <View style={{ flexDirection: 'row', gap: 8 }}>
                <SecondaryButton
                  accessible={true}
                  accessibilityLabel={i18n.t('header:save-project')}
                  accessibilityRole="button"
                  focusGroup={FocusGroups.MODAL_HEADER}
                  focusOrder={1}
                  focusId={TestIDs.REVIEW_LATER}
                  testID={modalTestID(TestIDs.ADJUST_CROPS, TestIDs.REVIEW_LATER)}
                  text={i18n.t('modal-adjust-crops:review-later')}
                  onPress={onPressReviewLater}
                  onFocus={e => e.stopPropagation()}
                  type={BUTTON_TYPES.DEFAULT}
                  size={BUTTON_SIZES.SMALL}
                  layout="fill"
                  style={{ flex: 1 }}
                />
                <PrimaryButton
                  accessible={true}
                  accessibilityLabel={i18n.t('modal-adjust-crops:save_and_close')}
                  accessibilityRole="button"
                  focusGroup={FocusGroups.MODAL_HEADER}
                  focusOrder={0}
                  focusId={TestIDs.SAVE_AND_CLOSE}
                  testID={modalTestID(TestIDs.ADJUST_CROPS, TestIDs.SAVE_AND_CLOSE)}
                  text={i18n.t('modal-adjust-crops:save_and_close')}
                  onPress={onPressSave}
                  onFocus={e => e.stopPropagation()}
                  size={BUTTON_SIZES.SMALL}
                  type={BUTTON_TYPES.DEFAULT}
                  layout="fill"
                  style={{ flex: 1 }}
                />
              </View>
            </Animated.View>
          )}
        </View>
      </Modal>
    );
  },
);
